/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// reactstrap components
/* eslint-disable */
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import api from "api";
import { getMediaUrl } from "../../config";
import {
  Card,
  CardHeader,
  Button,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Table,
  Container,
  Row,
  Progress,
} from "reactstrap";
import { baseUrl } from '../../config';

// core components
import RequestNewCodes from "./RequestNewCodes";
import EditBatchProduct from "./EditProduct";
import { toast } from "react-toastify";
import Loader from "components/Spinner/Spinner";
import { capitalString } from "utils/common";
import moment from "moment";
import { handleExportCodes } from "utils/exportCodes";
import { Store, UpdateStore } from "StoreContext";
import axios from 'axios';

const BrandCodesRequests = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [approveloading, setApproveloading] = useState(false);
  let [request, setRequest] = useState({
    name: "",
    text: "",
    numberOfCodes: 0,
    nfc: false,
    coaLink: "",
    productName: "",
    productImg: "",
  });
  const history = useHistory();
  const [allRequests, setAllRequests] = useState([]);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const { user } = Store();
  const updateStore = UpdateStore();
  const { exportLoading } = Store();

  useEffect(() => {
    getRequests();
  }, []);

  const getRequests = async () => {
    try {
      setLoading(true);
      const data = await api("get", "/requests");
      setAllRequests(data.requests);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  console.log("user1212", user)
  const handleModal = () => {
    setOpenModal((open) => !open);
    return openModal;
  };
  const handleProductModal = () => {
    setOpenEditProduct((open) => !open);
    return openEditProduct;
  };
  const handleEditModal = (item) => {
    if (item) {
      setRequest({
        _id: item._id,
        name: item.name,
        text: item.text,
        numberOfCodes: item.number_of_codes,
        nfc: item.code_type,
        coaLink: item.coaLink,
        productName: item.product_name,
        productImg: item.product_img,
      });
    }

    setOpenEditProduct((open) => !open);
    return openEditProduct;
  };

  const handleInvalidateRequest = (id) => {
    setLoading(true);
    api("patch", `/requests/invalidate/${id}`)
      .then(() => {
        toast.success("Codes has been invalidated for this request");
        getRequests();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleActivateRequest = (id) => {
    setLoading(true);
    api("patch", `/requests/validate/${id}`)
      .then(() => {
        toast.success("Request has been activated successfully");
        getRequests();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };


  function calculateTotalSize(number_of_codes) {
    const sizePerCodeMB = 40 / 600000; // MB per code
    const totalSizeMB = number_of_codes * sizePerCodeMB;
    const totalSizeKB = totalSizeMB * 1024;
    if (totalSizeKB < 1024) {
      return totalSizeKB * 1024; // Return size in bytes for uniformity
    } else {
      return totalSizeMB * 1024 * 1024; // Return size in bytes for uniformity
    }
  }

  /*    Export Codes against request    */
  const handleExportForRequest = async (id, reqName, item) => {
    let totalSize = calculateTotalSize(item.generated_code_by_increase ? item.generated_code_by_increase : item.number_of_codes);
    updateStore({
      exportLoading: true
    });

    try {
      const response = await axios.get(`${baseUrl}/codes/export?request=${id}`, {
        responseType: "blob",
        onDownloadProgress: (progressEvent) => {
          // Convert bytes to KB or MB
          const receivedSizeBytes = progressEvent.loaded;
          const receivedSizeKB = progressEvent.loaded / 1024;
          const receivedSizeMB = receivedSizeKB / 1024;
          const formattedSize =
            receivedSizeMB >= 1
              ? `${receivedSizeMB.toFixed(2)} MB`
              : `${receivedSizeKB.toFixed(2)} KB`;
          const progressPercentage = (receivedSizeBytes / totalSize) * 100;
          setProgress(progressPercentage);
          console.log(`Downloaded ${formattedSize}`, progressEvent);
          console.log("totalSize", totalSize);
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data], { type: "text/csv" }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${reqName}.csv`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

      setProgress(0);
      updateStore({
        exportLoading: false
      });
    } catch (error) {
      setProgress(0);
      updateStore({
        exportLoading: false
      });
      console.log('Error downloading the file:', error);
      toast.error('Failed to download the file');
    }
  };
  // const handleExportForRequest = async (request) => {
  //   console.log("request", request)
  //   setLoading(true);
  //   try {
  //     const response = await axios.get(`https://veriscan-serverless-azur-app.azurewebsites.net/api/exportCode?request=${request}&role=${"brand"}`);
  //     console.log("res.data", response.data)
  //     if (response.data.codes?.length > 0) {
  //       const codesToExport = response.data.codes;
  //       if (codesToExport.length > 0) {
  //         const currentDate = moment().format('MM_DD_yyyy');
  //         const fileName = `${user?.name.replace(/ /g, "_")}_${currentDate}`;
  //         handleExportCodes(codesToExport, fileName);
  //       } else {
  //         toast.error('No code exists');
  //       }
  //     } else {
  //       toast.error('No code exists');
  //     }
  //     toast.success('Codes exported successfully');
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.error('Error:', error);
  //   }
  // };

  const handleDelete = (id) => {
    setLoading(true);
    api("delete", `/requests/${id}`)
      .then(() => {
        toast.success("Request deleted successfully");
        getRequests();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Container fluid>
        {/* Table */}
        {loading && <Loader />}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <div className="d-flex justify-content-between ">
                  <h3 className="mb-0">Batch Requests</h3>
                  <Button color="primary" disabled={exportLoading} onClick={handleModal} size="md">
                    <i className="ni ni-fat-add"></i>
                    Request New Batch
                  </Button>
                </div>
              </CardHeader>
              {exportLoading && (
                <>
                  {" "}
                  {progress == 0 ? (
                    <Loader />
                  ) : (
                    <div className="blur-overlay">
                      <div className="progressbarDiv">
                        <p className="prgresstext1">Your codes are being exported</p>
                        <p className="prgresstext2">Please wait a few moments while your download is being prepared. Do not refresh the page.</p>
                        <Progress
                          className="my-2 h-3"
                          value={progress}
                          animated
                          style={{
                            height: "30px",
                            border: "1px solid #20659e",
                            // padding: "12px 0"
                          }}
                        >
                          {progress === 0
                            ? "Loading..."
                            : progress.toFixed(2) >= 99
                              ? "99"
                              : progress.toFixed(2)}{" "}
                          %
                        </Progress>
                      </div>
                    </div>
                  )}
                </>
              )}


              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Product Image</th>
                    <th scope="col">Batch Name</th>
                    <th scope="col"> Product Name</th>
                    <th scope="col">Number of Codes</th>
                    <th scope="col">Text</th>
                    <th scope="col">Code Type</th>
                    <th scope="col">Status</th>
                    <th scope="col">Created At</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
                  {allRequests?.map((item) => {
                    return (
                      <tr key={item?._id}>
                        <td title={item.product_img}>
                          {item.product_img && (
                            <img
                              src={getMediaUrl(item.product_img)}
                              alt="productimg"
                              className="productImg2"
                            />
                          )}
                        </td>
                        <th scope="row">
                          <Media className="align-items-center">
                            <Media>
                              <span className="mb-0 text-sm" title={item.name}>
                                {item.name?.length > 30
                                  ? item.name?.substring(0, 30) + "..."
                                  : item.name}
                              </span>
                            </Media>
                          </Media>
                        </th>

                        <td title={item.product_name}>{item.product_name}</td>
                        <td title={item.number_of_codes}>
                          {item.number_of_codes}
                        </td>
                        <td title={item.text}>
                          {item.text?.length > 45
                            ? item.text?.substring(0, 45) + "..."
                            : item.text}
                        </td>
                        <td>{item.code_type === "nfc" ? "NFC" : "Regular"}</td>
                        <td title={capitalString(item.status)}>
                          {capitalString(item.status)}
                        </td>
                        <td>
                          {moment(item.createdAt).format(
                            "MMMM DD, yyyy hh:mm A"
                          )}
                        </td>
                        <td className="text-right">
                          <UncontrolledDropdown disabled={exportLoading}>
                            {item.status !== "rejected" && (
                              <DropdownToggle
                                className="btn-icon-only text-light"
                                role="button"
                                size="sm"
                                // color=''
                                onClick={(e) => e.preventDefault()}
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                            )}
                            <DropdownMenu className="dropdown-menu-arrow" right>
                              {item.test_conducted && (
                                <DropdownItem
                                  onClick={() =>
                                    history.push(`/admin/users/${item._id}`)
                                  }
                                >
                                  View
                                </DropdownItem>
                              )}

                              {item.status === "pending" ? (
                                <>
                                  <DropdownItem
                                    className="text-danger"
                                    onClick={() =>
                                      handleInvalidateRequest(item._id)
                                    }
                                  >
                                    Invalidate
                                  </DropdownItem>
                                </>
                              ) : item.status === "approved" ? (
                                <DropdownItem
                                  className="text-danger"
                                  onClick={() =>
                                    handleInvalidateRequest(item._id)
                                  }
                                >
                                  Invalidate
                                </DropdownItem>
                              ) : (
                                item.status === "invalidated" && (
                                  <DropdownItem
                                    className="text-success"
                                    onClick={() =>
                                      handleActivateRequest(item._id)
                                    }
                                  >
                                    Activate
                                  </DropdownItem>
                                )
                              )}
                              {item.status !== "pending" && (
                                <DropdownItem
                                  onClick={() =>
                                    handleExportForRequest(item._id, item.name, item)
                                  }
                                >
                                  Export Codes
                                </DropdownItem>
                              )}
                              <DropdownItem
                                onClick={() => handleEditModal(item)}
                              >
                                Edit
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
        {openModal && (
          <RequestNewCodes
            setLoading={setLoading}
            openModal={openModal}
            handleModal={handleModal}
            getUsers={getRequests}
            externalBaseUrl={user?.websiteLink}
          />
        )}
        {openEditProduct && (
          <EditBatchProduct
            // setLoading={setLoading}
            openModal={openEditProduct}
            handleModal={handleProductModal}
            getUsers={getRequests}
            request={request}
            setRequest={setRequest}
          />
        )}
      </Container>
    </>
  );
};

export default BrandCodesRequests;
